module.exports = __webpack_public_path__ + "img/rancher-logo.055089a3.svg";